import './style.css'
import TableNex from "./tablenex";
export default TableNex ;
export * from "./types";